import { render, staticRenderFns } from "./BB-discovery.vue?vue&type=template&id=bbd8fbc0&scoped=true&"
import script from "./BB-discovery.vue?vue&type=script&lang=js&"
export * from "./BB-discovery.vue?vue&type=script&lang=js&"
import style0 from "./BB-discovery.vue?vue&type=style&index=0&id=bbd8fbc0&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd8fbc0",
  null
  
)

export default component.exports